module.exports = __webpack_public_path__ + "img/COCO.a5b83008.png";